import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { WhyChooseMe } from './components/WhyChooseMe';
import { Portfolio } from './components/Portfolio';
import { Testimonials } from './components/Testimonials';
import { Process } from './components/Process';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  return <div className="min-h-screen bg-black text-slate-300 selection:bg-blue-500/30" data-id="element-0" data-mp="2wk0ah3dhcrwk">
      <Navbar data-id="element-1" data-mp="2wi5nzkmk8rqd" />

      <main data-id="element-2" data-mp="28u5y0mx2p5cu">
        <Hero data-id="element-3" data-mp="28tw4ipctkg2e" />
        <About data-id="element-4" data-mp="28te21azkd5m1" />
        <Services data-id="element-5" data-mp="28suumo7jhzm9" />
        <WhyChooseMe data-id="element-6" data-mp="28sbb5328r364" />
        <Portfolio data-id="element-7" data-mp="23vchsmqej08z" />
        <Testimonials data-id="element-8" data-mp="23vupcfiil0w7" />
        <Process data-id="element-9" data-mp="23ujk0b9f7l2z" />
        <Pricing data-id="element-10" data-mp="23v2s7099qv3t" />
        <FAQ data-id="element-11" data-mp="23ti864kkyuk7" />
        <Contact data-id="element-12" data-mp="3ijxsgzk2wgo4" />
      </main>

      <Footer data-id="element-13" data-mp="3iiwdwl3utc1n" />
    </div>;
}